<template>
	<div id="SelectSize" :class="{ active: modalActive }">
		<div class="container">
			<div class="close" @click.prevent="(e) => $emit('modalHide', 'hide')" v-if="!$store.getters['dom/isMobile']">

				<img src="@/assets/images/close.svg" />

			</div>
			<div class="close closeMobile" @click.prevent="(e) => $emit('modalHide', 'hide')" v-else>

				<img src="@/assets/images/x.svg" />

			</div>
			<div class="content">

				<div class="title">
					LEARN MORE ABOUT<br />SEASON TICKET MEMBERSHIPS
				</div>
				<div class="success" :class="[success ? 'active' : '']">
					<!-- <div class="close" @click.prevent="(e) => $emit('modalHide', 'hide')">
						<img src="@/assets/images/x.svg" />
					</div> -->
					Thank you for requesting to speak with an Islanders Ticket
					Representative.<br />
					A member of our team will be in touch with you shortly.
				</div>
				<form
				action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
				method="POST"
				>
				<!-- action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" -->
				<!-- <form  @submit.prevent="getFormValues"> -->
				<input type="hidden" name="oid" value="00D4600000102aZ">
				<input
				type="hidden"
				name="retURL"
				value="https://islanders.vipfanportal.com/2023sales/thankyou"
				/>

				<div class="formEntries">
					<div class="form-field-inputs">
						<label for="first_name">First Name</label>
						<input
						id="first_name"
						placeholder="ENTER FIRST NAME"
						maxlength="40"
						name="first_name"
						size="20"
						type="text"
						required
						/>
					</div>

					<div class="form-field-inputs">
						<label for="last_name">Last Name</label
							><input
							id="last_name"
							placeholder="ENTER LAST NAME"
							maxlength="80"
							name="last_name"
							size="20"
							type="text"
							required
							/>
						</div>
					</div>
					<div class="formEntries" style="width:100%; display: block;">
						<div class="form-field-inputs">
							<label for="email">Email</label
								><input
								id="email"
								placeholder="ENTER EMAIL ADDRESS"
								maxlength="80"
								name="email"
								size="20"
								type="text"
								required
								style="width:100%;"
								/>
							</div>

						</div>
						<div class="formEntries">
							<div class="form-field-inputs">
								<label for="phone">Phone</label>
								<input
								type="text"
								id="phone"
								name="phone"
								placeholder="ENTER PHONE NUMBER"
								maxlength="10"
								size="20"
								pattern="[0-9]{10}"
								required
								/>
								<!-- <input  id="phone" maxlength="40" name="phone" size="20" type="text" required /> -->
							</div>
							<div class="form-field-inputs">
								<label for="zip">Zipcode</label
									><input
									id="zip"
									placeholder="ENTER ZIPCODE"
									maxlength="80"
									name="zip"
									size="20"
									type="text"
									required
									/>
								</div>

							</div>
						<!-- <div class="talkToRep" style="display:none"> -->
						<!-- <label for="marketing" style="display: none">
							Marketing Opt In:
							<input
							id="00N4p00000FmVRN"
							name="00N4p00000FmVRN"
							type="hidden"
							value="True"
							/>
						</label> -->
						<!-- </div> -->

						<label for="rep" style="width: 100%; display: none">
							<input id="rep" name="00N4p00000FlhSn" type="hidden"  value="True" />
							<!-- <input  id="00N4p00000FlhSn" name="00N4p00000FlhSn" type="checkbox" value="True" /> -->
							<!-- <input  id="00N4p00000FlhSn" name="00N4p00000FlhSn" type="checkbox" value="1" /> -->

							<!-- v-model="enabled" :value="enabled" -->
							<!-- I would like to talk to a rep about New York Islanders Ticket
							Memberships or Premium Hospitality at UBS Arena -->
						</label>

						<div class="talkToRep premiumTalkToRep">
							<label for="rep" style="width: 100%">
								<!-- id="00N4p00000GIARS" -->
								<input
								id="rep"
								name="00N4p00000GIARS"
								type="checkbox"
								v-model="enabled"
								:value="enabled"
								/>
								<!-- v-model="enabled" :value="enabled" -->
								<!-- I would like to speak to an Account Manager about Club Seats or
								Suites at UBS Arena. -->
								I am also interested in speaking to an Account Manager about Club Seats or Suites at UBS Arena.
							</label>
						</div>

						<!-- GA ID: -->
						<input
						id="00N4p00000G9NIA"
						maxlength="201"
						name="00N4p00000G9NIA"
						size="20"
						type="hidden"
						/>

						<!-- Web Form Source: -->
						<input
						id="utm_source"
						maxlength="100"
						name="00N4p00000G9NI5"
						size="20"
						type="hidden"
						/>

						<!-- Web Form Campaign: -->
						<input
						id="utm_campaign"
						maxlength="100"
						name="00N4p00000G9NIF"
						size="20"
						type="hidden"
						/>

						<!-- Web Form Medium: -->
						<input
						id="utm_medium"
						maxlength="100"
						name="00N4p00000G9NIK"
						size="20"
						type="hidden"
						/>

						<!-- Web Form Prospect: -->
						<!-- <input
						id="utm_term"
						maxlength="100"
						name="00N4p00000FlhCp"
						size="20"
						type="hidden"
						/> -->

						<!-- Web Form Content: -->
						<input
						id="utm_content"
						maxlength="201"
						name="00N4p00000G9RcE"
						size="20"
						type="hidden"
						/>

						<label for="web-to-lead" style="display: none"
						>From Web-to-Lead (Text):</label
						>
						<!-- <input
						id="00N4p00000G2PrA"
						maxlength="255"
						name="00N4p00000G2PrA"
						size="20"
						value="true"
						type="hidden"
						/> -->
						<input  id="00N4p00000G2PrA"
						maxlength="255"
						name="00N4p00000G2PrA"
						size="20"
						type="hidden" value="true"
						/>

						<input
						id="00N4p00000G9ONk"
						maxlength="50"
						name="00N4p00000G9ONk"
						value="New Business Page 23-24"
						size="20"
						type="hidden"
						/>
						 <!-- <input  id="00N4p00000G9ONk" maxlength="50" name="00N4p00000G9ONk" size="20" type="text" /> -->
						<div class="webFormProduct" style="display: none">
							<label for="web-form-product"
							>Web Form Product:</label
							>
							<!-- style="display: none" -->
							<select  id="00N4p00000G9NMl" multiple="multiple" name="00N4p00000G9NMl" title="Web Form Product"><option value="Premium Suites and Clubs at Belmont Park Arena">Premium Suites and Clubs at Belmont Park Arena</option>
							<option value="Sponsorship opportunities at Belmont Arena">Sponsorship opportunities at Belmont Arena</option>
							<option value="Islanders Season Ticket Memberships">Islanders Season Ticket Memberships</option>
							<option value="General Seating">General Seating</option>
							<option value="Special Event">Special Event</option>
							</select>
						</div>
						<input class="submit" type="submit" name="submit" />
						<!-- @click="submitForm()" -->

						<label class="terms_acceptance">
							<input
							id="terms_acceptance"
							name="terms_acceptance"
							value="Yes"
							type="hidden"
							/>
							By submitting this form, I agree to receive phone call(s)
							from an account manager about ticket memberships and email, phone, and SMS marketing
							communications from the New York Islanders and UBS Arena.
						</label>
						<!-- </div> -->
					</form>
				</div>
			</div>
		</div>
	</template>

	<script>
	import { reactive, toRefs, computed } from "vue";
	import { useStore } from "vuex";
	// import axios from "axios";

	export default {
		name: "joinUs",
		props: ["modalActive"],
		emits: ["modalHide"],

		data() {
			return {
				success: false,
				enabled: false,
				// web_form_product: '',
				output:{
					// utm_source : '',
					// utm_medium : '',
					// utm_campaign : '',
					// // utm_term : '',
					// utm_content : '',
					// web_form_product: '',
					// first_name : '',
					// last_name : '',
					// email : '',
					// zip : '',
					// phone : '',
					// rep : '',
				}
			};
		},
		mounted() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);

			window.addEventListener("resize", () => {
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			});

			var gaUserId = document.cookie
			  .match(/_ga=(.+?);/)[1]
			  .split(".")
			  .slice(-2)
			  .join(".");
			document.getElementById("00N4p00000G9NIA").value = gaUserId;
			console.log(gaUserId);

			const parseGET = function (param) {
			  var searchStr = document.location.search;
			  try {
			    var match = searchStr.match("[?&]" + param + "=([^&]+)");
			    if (match) {
			      var result = match[1];
			      result = result.replace(/\+/g, "%20");
			      result = decodeURIComponent(result);
			      return result;
			    } else {
			      return "";
			    }
			  } catch (e) {
			    return "";
			  }
			};

			document.getElementById("utm_source").value = parseGET("utm_source");
			document.getElementById("utm_medium").value = parseGET("utm_medium");
			document.getElementById("utm_campaign").value = parseGET("utm_campaign");
			// document.getElementById("utm_term").value = parseGET("utm_term") ?  parseGET("utm_term")  : '';
			document.getElementById("utm_content").value = parseGET("utm_content");
		},
		methods: {
			submitForm() {
				this.success = true;
			},
			getFormValues (submitEvent) {
					// this.output.utm_source = submitEvent.target.elements.utm_source.value
					// this.output.utm_medium =submitEvent.target.elements.utm_medium.value
					// this.output.utm_campaign =submitEvent.target.elements.utm_campaign.value
					// // this.output.utm_term =submitEvent.target.elements.utm_term.value
					// this.output.utm_content =submitEvent.target.elements.utm_content.value
					// this.output.first_name =submitEvent.target.elements.first_name.value
					// this.output.last_name =submitEvent.target.elements.last_name.value
					// this.output.email =submitEvent.target.elements.email.value
					// this.output.zip =submitEvent.target.elements.zip.value
					// this.output.phone =submitEvent.target.elements.phone.value
					// this.output.rep =submitEvent.target.elements.rep.value
					// console.log(this.output);

			}
		},
	};
	</script>

	<style lang="scss" scoped>
	#SelectSize {
		background: rgba(0, 0, 0, 0.74);
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: calc(var(--vh, 1vh) * 100);
		max-height: 0;
		opacity: 0;
		transition: all 0.5s ease-in-out;
		overflow: hidden;
		z-index: 99;
		&.active {
			max-height: calc(var(--vh, 1vh) * 100);
			opacity: 1;
			z-index: 1000;
			transition: all 0.5s ease-in-out;
		}
		.container {
			position: absolute;
			top:50%;
			left: 50%;
			transform: translate(-25%, -50%);

			// display: flex;
			// justify-content: center;
			// align-items: center;
			height: auto;
			width: 100%;
			// position: relative;
			@include media-breakpoint-down(sm) {
				// margin-top:20px;
				top:50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
		.close {
			position: absolute;
			top: -40px;
			right: 50%;
			height: fit-content;
			width: fit-content;
			cursor: pointer;
			@include media-breakpoint-down(sm) {
				// top: 5px;
				right: 5%;
			}
		}
		.closeMobile{
			top: 3%;
			z-index:1;
		}
		.content {
			position: relative;

			width: 650px;
			max-width: 100%;
			background: #FFFFFF;
			// margin: auto 0px;
			// background-image: linear-gradient(180deg, #ffffff 0%, #e2e2e2 100%);
			box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.5);
			@include media-breakpoint-down(sm) {
				// padding: 39px 25px 45px 25px;
				min-width: 348px;
				overflow-x: scroll;
			}

			form {
				padding: 25px 37px;
				@include media-breakpoint-down(sm) {
					padding: 15px 27px;
				}
				.formEntries{
					display: flex;
					flex-direction:row;
					justify-content: space-between;
					@include media-breakpoint-down(sm) {
						flex-direction:column;
					}
				}
				.form-field-inputs {
					margin-right: 10px;
					// display: flex;
					// flex-direction:row;
					// justify-content: space-between;
					margin-bottom: 20px;
					@include media-breakpoint-down(sm) {
						margin-bottom: 10px;
					}
				}
				label {
					width: 200px;
					// flex: 30%;
					color: theme-var($--ch-theme-primary);
					font-family: "GeogrotesqueSharp-Md";
				}
				input[type="text"] {
					width: 100%;
					font-family: "GeogrotesqueSharp-Md";
					// text-transform: uppercase;
					background: #FFFFFF;
					border: 1.5px solid #D0D0D0;
					padding:10px;
					font-size: 12px;

				}
				// input[type=checkbox] { flex: 30%;
				// 	position: absolute;
				// 	left: 50%;
				// 	@include media-breakpoint-down(sm) {
				// 		left: 43%;
				// 	}
				// }
			}
			.talkToRep {
				padding-left: 45px;
				text-indent: -25px;
				margin-bottom: 10px;
				input[type="checkbox"] {
					width: 20px;
				}
				@include media-breakpoint-down(sm) {
					font-size: 12px;
				}
			}

			.title {
				background: #FAFAFA;
				padding: 25px 57px;
				color: theme-var($--ch-theme-secondary);
				text-transform: uppercase;
				margin-bottom: 15px;
				font-family: "GeogrotesqueSharp-ExpBd";
				font-size: 25px;
				letter-spacing: 0;
				text-align: center;
				line-height: 23px;
				font-weight: 700;
				@include media-breakpoint-down(sm) {
					font-size: 16px;
					line-height: 16px;
					padding: 15px 27px;
				}
			}
			.dropdown {
				position: relative;
				height: 46px;
				width: 288px;
				padding: 0 18.5px 0 23px;
				background: #ffffff;
				border: 1px solid #b4b4b4;
				margin: 0 auto;
				.display {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					height: 100%;
					width: 100%;
					cursor: pointer;
					span {
						font-family: "GeogrotesqueSharp-Md";
						font-size: 13px;
						color: #000000;
						letter-spacing: 0;
						line-height: 33px;
						font-weight: 400;
					}
				}
				.menu {
					position: absolute;
					top: 45px;
					left: -1px;
					width: 288px;
					max-height: 0;
					background: #ffffff;
					border: 1px solid #b4b4b4;
					border-top: none;
					border-bottom: none;
					overflow: hidden;
					transition: max-height 0.3s ease-in-out;
					&.active {
						max-height: 500px;
						border-bottom: 1px solid #b4b4b4;
						transition: max-height 0.3s ease-in-out;
					}
					&Inner {
						display: flex;
						flex-direction: column;
						height: fit-content;
						width: 288px;
						padding: 18.5px 18.5px 20.5px 23px;
						span {
							font-family: "GeogrotesqueSharp-Md";
							font-size: 13px;
							color: #000000;
							letter-spacing: 0;
							line-height: 33px;
							font-weight: 400;
							cursor: pointer;
						}
					}
				}
			}
			.terms_acceptance{
				width: 100%;
				font-size: 12px;
				margin-top: 20px;
				color: #A2A2A2;
				@include media-breakpoint-down(sm) {
					margin-top: 10px;
					font-size: 9px;
				}
			}
			.checks {
				display: flex;
				flex-direction: column;
				margin: 40px 0;
				h4 {
					color: black;
					font-size: 16px;
					font-family: "GeogrotesqueSharp-Md";
				}
				.check-item {
					display: flex;
					flex-direction: row;
					align-items: center;
					@include media-breakpoint-down(sm) {
						align-items: baseline;
					}
					.box {
						display: flex;
						justify-content: center;
						align-items: center;
						height: 17px;
						width: 17px;
						background: #ffffff;
						border: 1px solid #b4b4b4;
						margin-right: 14px;
						cursor: pointer;
						@include media-breakpoint-down(sm) {
							height: 15px;
							width: 20px;
						}
						&.active {
							img {
								opacity: 1;
								transition: opacity 0.2s ease-in-out;
							}
						}
						img {
							opacity: 0;
							transition: opacity 0.2s ease-in-out;
						}
					}
					span {
						font-family: "GeogrotesqueSharp-Md";
						font-size: 13px;
						color: #000000;
						letter-spacing: 0;
						line-height: 33px;
						font-weight: 400;
					}
				}
			}

			.submit {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 46px;
				width: 192px;
				background: theme-var($--ch-theme-secondary);
				border: 2px solid theme-var($--ch-theme-secondary);
				font-family: "GeogrotesqueSharp-Md";
				font-size: 22px;
				color: #ffffff;
				letter-spacing: 0;
				text-align: center;
				font-weight: 700;
				text-transform: uppercase;
				margin: 0 auto;
				cursor: pointer;
				margin-top: 30px;

				transition: all 0.3s ease-in-out;
				@include media-breakpoint-down(sm) {
					margin-top: 15px;
					height: 26px;
					width: 132px;
					font-size: 14px;
				}
				&:hover {
					background: #ffffff;
					color: theme-var($--ch-theme-primary);
					border: 2px solid theme-var($--ch-theme-primary);
				}
			}
			.success {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				width: 100%;
				background-image: linear-gradient(180deg, #ffffff 0%, #e2e2e2 100%);
				justify-content: center;
				align-items: center;
				font-family: "GeogrotesqueSharp-Bd";
				font-size: 22px;
				padding: 30px;
				color: theme-var($--ch-theme-primary);
				letter-spacing: 0;
				text-align: center;
				font-weight: 700;
				// text-transform: uppercase;
				display: none;
				&.active {
					display: flex;
				}
			}
		}
	}
	</style>
